export default {
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  "no-padding": () => import("/vercel/path0/layouts/noPadding.vue").then(m => m.default || m),
  "no-scroll": () => import("/vercel/path0/layouts/noScroll.vue").then(m => m.default || m),
  "no-scroll-no-padding": () => import("/vercel/path0/layouts/noScrollNoPadding.vue").then(m => m.default || m)
}